/*
 *+------------------------------------------------------------------------+
 *| Licensed Materials - Property of IBM
 *| IBM Cognos Products: SHARE
 *| (C) Copyright IBM Corp. 2017, 2018
 *|
 *| US Government Users Restricted Rights - Use, duplication or disclosure
 *| restricted by GSA ADP Schedule Contract with IBM Corp.
 *+------------------------------------------------------------------------+
 */
// eslint-disable-next-line no-undef
requirejs.config({
	paths: {
		'storytelling': 'js/storytelling',
		'storytelling-ui': 'storytelling-ui'
	}
});
